<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            v-if="isTemplateListValid"
            :data="broadcasters"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="heading">
                {{ $t("setup.label.TemplateDefinition") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Template' })"
                  size="small"
                  >{{ $t("setup.label.CreateTemplateDefinition") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.TemplateName") }}</vs-th>
              <vs-th>{{ $t("setup.label.Delimiter") }}</vs-th>
              <vs-th>{{ $t("setup.label.NumberOfFields") }}</vs-th>
              <vs-th>{{ $t("setup.label.HeaderRecorderType") }}</vs-th>
              <vs-th>{{ $t("setup.label.EventRecordType") }}</vs-th>
              <vs-th>{{ $t("setup.label.ServiceCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.ProductCode") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="data"
                v-for="(broadcasters, index) in data"
              >
                <vs-td :data="broadcasters.templateName">{{
                  broadcasters.templateName
                }}</vs-td>
                <vs-td :data="broadcasters.delimiter">{{
                  broadcasters.delimiter
                }}</vs-td>
                <vs-td :data="broadcasters.numberOfFields">{{
                  broadcasters.numberOfFields
                }}</vs-td>
                <vs-td :data="broadcasters.headerecordtype">{{
                  broadcasters.headerecordtype
                }}</vs-td>
                <vs-td :data="broadcasters.eventrecordtype">{{
                  broadcasters.eventrecordtype
                }}</vs-td>
                <vs-td :data="broadcasters.serviceCode">{{
                  broadcasters.serviceCode || "-"
                }}</vs-td>
                <vs-td :data="broadcasters.productCode">{{
                  broadcasters.productCode || "-"
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected1(broadcasters)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                      @click.stop="EditTemplateData(broadcasters.templateId)"
                      class="icon_row"
                    />

                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor "
                      @click.stop="
                        // stateChange('broadcasters');
                        editJobsPopup = true;
                        delId = broadcasters.templateId;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="'Delete ' + $t('setup.label.TemplateDefinition')"
        :active.sync="editJobsPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="editJobsPopup = false">{{
              $t("setup.label.Cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteTemplateDefinition(delId)">{{
              $t("setup.label.Confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
    isTemplateListValid() {
      return Array.isArray(this.broadcasters);
    },
  },
  methods: {
    EditTemplateData(id) {
      this.$router.push({ name: "Edit Template", params: { id: id } });
    },

    async getbroadcasterData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setTemplateList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    handleSelected1(broadcasters) {
      this.$router.push({
        name: "View Template",
        params: { id: broadcasters.templateId },
      });
    },
    async deleteTemplateDefinition(id) {
      try {
        await this.$store.dispatch(
          "usageRating/deleteTemplateDefinitionAction",
          id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Template Definition Successfully Deleted",
          type: "success",
        });
        this.getbroadcasterData();
        this.editJobsPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  async mounted() {
    await this.getbroadcasterData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
